"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cache_1 = require("../cache");
var MmxlCacheAdapter = (function () {
    function MmxlCacheAdapter(mmxl) {
        this._mmxl = mmxl;
        this._ratecardCache = new cache_1.Cache();
        this._targetingCache = new cache_1.Cache();
        this._frequencyCappingCache = new cache_1.Cache();
        this._standardAdformatCache = new cache_1.Cache();
        this._countCache = new cache_1.Cache();
    }
    MmxlCacheAdapter.prototype.getCaches = function () {
        return {
            ratecardCache: this._ratecardCache,
            targetingCache: this._targetingCache,
            frequencyCappingCache: this._frequencyCappingCache,
            standardAdformatCache: this._standardAdformatCache,
            countCache: this._countCache
        };
    };
    MmxlCacheAdapter.prototype.setCaches = function (caches) {
        this._ratecardCache = caches.ratecardCache;
        this._targetingCache = caches.targetingCache;
        this._frequencyCappingCache = caches.frequencyCappingCache;
        this._standardAdformatCache = caches.standardAdformatCache;
        this._countCache = caches.countCache;
    };
    MmxlCacheAdapter.prototype.getAnalyses = function () {
        return this._mmxl.getAnalyses();
    };
    MmxlCacheAdapter.prototype.getAnalysis = function (analysisId) {
        return this._mmxl.getAnalysis(analysisId);
    };
    MmxlCacheAdapter.prototype.getMedia = function (analysisId, where) {
        return this._mmxl.getMedia(analysisId, where);
    };
    MmxlCacheAdapter.prototype.searchMedia = function (analysisId, where, options) {
        return this._mmxl.searchMedia(analysisId, where, options);
    };
    MmxlCacheAdapter.prototype.getMarketers = function (analysisId, where) {
        return this._mmxl.getMarketers(analysisId, where);
    };
    MmxlCacheAdapter.prototype.searchMarketers = function (analysisId, where) {
        return this._mmxl.searchMarketers(analysisId, where);
    };
    MmxlCacheAdapter.prototype.evalPlanDetails = function (analysisId, plan) {
        return this._mmxl.evalPlanDetails(analysisId, plan);
    };
    MmxlCacheAdapter.prototype.tryToGetItemFromCache = function (cache, getterMethod, key) {
        var result = cache.get(key);
        if (!result) {
            result = getterMethod(key);
            cache.set(key, result);
        }
        return result;
    };
    MmxlCacheAdapter.prototype.getRateCard = function (bookingUnitId, options) {
        var _this = this;
        var key = bookingUnitId + JSON.stringify(options);
        return this.tryToGetItemFromCache(this._ratecardCache, function () { return _this._mmxl.getRateCard(bookingUnitId, options); }, key);
    };
    MmxlCacheAdapter.prototype.getFrequencyCappingKit = function (frequencyCappingKitId) {
        var _this = this;
        return this.tryToGetItemFromCache(this._frequencyCappingCache, function () { return _this._mmxl.getFrequencyCappingKit(frequencyCappingKitId); }, frequencyCappingKitId);
    };
    MmxlCacheAdapter.prototype.getTargetingKit = function (targetingKitId) {
        var _this = this;
        return this.tryToGetItemFromCache(this._targetingCache, function () { return _this._mmxl.getTargetingKit(targetingKitId); }, targetingKitId);
    };
    MmxlCacheAdapter.prototype.getStandardAdFormats = function (options) {
        var _this = this;
        return this.tryToGetItemFromCache(this._standardAdformatCache, function () { return _this._mmxl.getStandardAdFormats(options); }, JSON.stringify(options));
    };
    MmxlCacheAdapter.prototype.getTargetingTree = function (id) {
        return this._mmxl.getTargetingTree(id);
    };
    MmxlCacheAdapter.prototype.countAnalysis = function (analysisId, input) {
        var _this = this;
        return this.tryToGetItemFromCache(this._countCache, function () { return _this._mmxl.countAnalysis(analysisId, input); }, JSON.stringify(input));
    };
    MmxlCacheAdapter.prototype.getPrintAdFormats = function (kind, norm) {
        return this._mmxl.getPrintAdFormats(kind, norm);
    };
    return MmxlCacheAdapter;
}());
exports.MmxlCacheAdapter = MmxlCacheAdapter;
//# sourceMappingURL=mmxlCacheAdapter.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/adapters/mmxlCacheAdapter.js
// module id = 9
// module chunks = 0